import { AppStatus } from '@/redux'
import { analytics, APIClient } from '@/services'
import { updateLessonsOpenedCount } from '@/utils'
import { AnyFunction } from '@codeleap/types'
import React from 'react'
import { LessonCTAWrapperProps } from '../types'
import { ModalLessonDone } from '../modals'

export function useLessonCTASideEffects(props: LessonCTAWrapperProps) {
  const { chapter, module, type } = props

  return React.useCallback((callback: AnyFunction) => {
    analytics?.track?.('lesson_complete')
    updateLessonsOpenedCount({ ...chapter, done: true })

    if (APIClient.Session.isLoggedIn()) {
      APIClient.Learn.chaptersManager.refresh()
      APIClient.Learn.modulesManager.refresh()
    }

    AppStatus.set('splash')
    ModalLessonDone.close()
    callback()
  }, [chapter, module, type])
}
